import React from 'react';
import { connect } from 'react-redux';
import FiltroDashboard from './Components/FiltroDashboard';
import { fetchDashboardTotalizadores, setFiltroDashboard } from '../../../actions/dashboardActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import { formatoDecimal } from '../../../utilities/formatoNumeros';
import { filtroUnDia } from '../../../utilities/fechasFiltro';
import BigSpinner from "../../General/BigSpinner";
import './Styles/Dashboard.css'
import BtnToggleFilter from "../../General/Filter/BtnToggleFilter";

const fechaFiltro = filtroUnDia();

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
    }
  }


  componentDidMount() {
    if (!this.props.userType.isSoloLectura) {
      this.busqueda();
    }
  }

  busqueda = () => {

    let idSeller = this.props.idSeller;
    let filtroDashboard = this.props.filtroDashboard;

    if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
      idSeller = null;
    }

    if (filtroDashboard.fechaDesde === undefined) {
      filtroDashboard.fechaDesde = fechaFiltro.hasta;
    }

    if (filtroDashboard.verMes === undefined) {
      filtroDashboard.verMes = false;
    }

    this.setState({ filterOptions: filtroDashboard });

    this.props.fetchDashboardTotalizadores({
      fechaDesde: filtroDashboard.fechaDesde,
      verMes: filtroDashboard.verMes,
      tipoUser: this.props.tipoUsuario,
      idSeller: idSeller
    });
  }

  chargeFilterOptions = (options) => {
    this.props.setFiltroDashboard(options);
    this.setState({ filterOptions: options });
  }


  render() {

    const { ventas, ordenes, publicaciones, isLoading } = this.props

    const totalizadores = [
      {
        nombre: "Ventas",
        icono: "mx-2 mdi mdi-square-inc-cash",
        atributos: [
          { nombre: "Total Ventas Aprobadas", valor: "$" + formatoDecimal(`${ventas.total}`) },
          { nombre: "Total Ventas Pendientes Aprobación", valor: "$" + formatoDecimal(`${ventas.pendientes}`) },
          { nombre: "Comisión (sin iva)", valor: "$" + formatoDecimal(`${ventas.comision}`) },
          { nombre: "$ Fee logístico (sin iva)", valor: "$" + formatoDecimal(`${ventas.feeLogistico}`) },
          { nombre: "Ticket Promedio", valor: "$" + formatoDecimal(`${ventas.ticketPromedio}`) },
          { nombre: "Cantidad de unidades", valor: ventas.unidades },
          { nombre: "Ordenes Anuladas", valor: "$" + formatoDecimal(`${ventas.ordenesAnuladasGateway}`) },
          { nombre: "Ordenes Pendientes", valor: "$" + formatoDecimal(`${ventas.ordenesPendientesGateway}`) },
          { nombre: "Total Ventas", valor: "$" + formatoDecimal(`${ventas.totalVenta}`) }
        ],
      },
      {
        nombre: "Órdenes",
        icono: "mx-2 sl-icon-basket",
        atributos: [
          { nombre: "Totales", valor: ordenes.total },
          { nombre: "Total Pendientes Aprobación", valor: ordenes.pendientes },
          { nombre: "Total Pago Rechazado", valor: ordenes.anuladas },
          { nombre: "Facturadas", valor: ordenes.facturadas },
          { nombre: "Pendientes de facturación", valor: ordenes.pendientesFacturacion },
          { nombre: "Facturadas anuladas", valor: ordenes.facturadasAnuladas },
          { nombre: "Con envío procesado", valor: ordenes.envioProcesado },
          { nombre: "Con envío pendiente", valor: ordenes.envioPendiente }
        ],
      },
      {
        nombre: "Publicaciones",
        icono: "mx-2 mdi mdi-tag-multiple",
        atributos: [
          { nombre: "Totales", valor: publicaciones.total },
          { nombre: "Activas", valor: publicaciones.activas },
          { nombre: "Pendientes", valor: publicaciones.pendientes },
          { nombre: "En revisión", valor: publicaciones.enRevision },
          { nombre: "Pausadas con stock", valor: publicaciones.pausadasConStock },
          { nombre: "Pausadas sin stock", valor: publicaciones.pausadasSinStock }
        ],
      }
    ];
  return (
      <>
        {!this.props.userType.isSoloLectura && !this.props.userType.isProveedor &&
          <div className="container">

            <div className="row">
              <div className="col-12 text-right">
                <BtnToggleFilter show={this.state.showFilter} handleShow={() => this.setState({ showFilter: !this.state.showFilter })} />
              </div>
            </div>

            <div hidden={!this.state.showFilter}>
              <FiltroDashboard
                filtro={this.props.emptyFiltro.dashboard === false ? this.props.filtroDashboard : ""}
                chargeFilterOptions={this.chargeFilterOptions}
              />
            </div>

            {
              isLoading ? <BigSpinner /> :
                <div className="row position-relative">
                  {
                    totalizadores.map((totalizador, i) => {
                      return (
                        <div key={i} className="col-12 text-center">

                          <div className="row justify-content-center animated fadeIn">
                            <div className="col-12 col-sm-9 col-md-5 dashboard-titulo color-blanco-megatone">
                              <i className={totalizador.icono} />
                              <h4 className="d-inline color-blanco-megatone">{totalizador.nombre}</h4>
                            </div>
                          </div>

                          <div className="row justify-content-around dashboard-container">
                            {
                              totalizador.atributos.map((atributo, j) => {
                                return (
                                  <div key={j} className="col-12 col-sm-6 col-md-4 dashboard-atributos hover-background-color animated zoomIn">
                                    <h4 className="d-block mt-3 mb-2">{atributo.valor}</h4>
                                    <h6 className="d-block mt-2">{atributo.nombre}</h6>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
            }
          </div>
        }
      </>
    )
  }
}


const mapStateToProps = state => ({
  idSeller: state.general.idSeller,
  ventas: state.dashboard.totalizadores.ventas,
  ordenes: state.dashboard.totalizadores.ordenes,
  publicaciones: state.dashboard.totalizadores.publicaciones,
  isLoading: state.dashboard.isLoading,
  filtroDashboard: state.dashboard.filtro,
  emptyFiltro: state.general.limpiar,
  userType: state.general.userType
});

export default connect(mapStateToProps, {
  fetchDashboardTotalizadores,
  setFiltroDashboard,
  limpiarFiltros
})(Dashboard);